module.exports = __webpack_public_path__ + "static/media/YF40_4.b9805e00.jpg";